class ProductCardQuickAdd extends HTMLElement {
  static get observedAttributes () {
    return ['data-initialized']
  }

  constructor () {
    super()
    this.elements = {
      triggers: [],
      prevButtons: this.querySelectorAll('[data-product-card-quick-add-el="prev"]'),
      nextButtons: this.querySelectorAll('[data-product-card-quick-add-el="next"]'),
      lists: this.querySelectorAll('[data-product-card-quick-add-el="list"]'),
      lengths: this.querySelectorAll('.prd-LengthSelectorWrapper'),
      cartItems: document.querySelector('cart-items'),
    }

    this.state = {
      addingToCart: false,
    }
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'data-initialized' && newValue === 'true') {
      this.elements.triggers = this.querySelectorAll('[data-product-card-quick-add-el="trigger"]')
      this.attachEventListeners()

      if (!this.elements.lists) return

      this.updateButtonVisibility()

      this.elements.lists.forEach(list => {
        list.addEventListener('scroll', this.updateButtonVisibility.bind(this))
      })
    }
  }

  attachEventListeners () {
    this.elements.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => this.addProduct(e))
    })

    this.elements.prevButtons.forEach(btn => {
      btn.addEventListener('click', (e) => this.scrollContainer('prev', e))
    })
    this.elements.nextButtons.forEach(btn => {
      btn.addEventListener('click', (e) => this.scrollContainer('next', e))
    })

    if (!this.elements.lengths) return

    this.elements.lengths.forEach(lengthlink => {
      lengthlink.addEventListener('click', this.updateButtonVisibility.bind(this))
    })
  }

  async addProduct (e) {
    e.preventDefault()
    const handle = Number(e.target.getAttribute('data-id'))
    const lengthType = e.target.dataset.lengthType
    const quantity = 1

    this.addingToCart = true

    const properties = {}
    if (lengthType && lengthType.trim() !== '') properties.Length = lengthType

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sections: this.elements.cartItems.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
        items: [
          {
            id: handle,
            quantity,
            ...(Object.keys(properties).length && { properties }),
          },
        ],
      }),
    })

    if (response.ok) {
      const json = await response.json()

      this.elements.cartItems?.renderContents(json)
      this.addingToCart = false

      if (this.closest('[data-root="autocomplete"]')) {
        window.theme.category.eventBus.publish('autocomplete:tracking:product:added', {
          type: 'autocomplete',
          productId: json.items[0].id,
          url: json.items[0].url,
        })
      }

      if (this.closest('[data-root="category"]')) {
        window.theme.category.eventBus.publish('category:tracking:product:added', {
          type: 'category',
          productId: json.items[0].id,
          url: json.items[0].url,
        })
      }

      if (this.closest('[data-root="searchResults"]')) {
        window.theme.searchResults.eventBus.publish('searchResults:tracking:product:added', {
          type: 'serp',
          productId: json.items[0].id,
          url: json.items[0].url,
        })
      }

      const addToCartEvent = new CustomEvent('GA_ADD_TO_CART', {
        detail: {
          formName: 'quickBuy',
          item: json.items[0],
        },
      })
      window.dispatchEvent(addToCartEvent)
    } else {
      console.error('Failed to add product to cart')
    }
  }

  scrollContainer (direction, e) {
    const list = e.target.closest('button').parentNode.querySelector('[data-product-card-quick-add-el="list"]')
    const scrollAmount = list.clientWidth

    if (direction === 'prev') {
      list.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
    } else if (direction === 'next') {
      list.scrollBy({ left: scrollAmount, behavior: 'smooth' })
    }

    setTimeout(() => this.updateButtonVisibility(), 300)
  }

  updateButtonVisibility () {
    this.elements.lists.forEach((list, index) => {
      const prevButton = this.elements.prevButtons[index]
      const nextButton = this.elements.nextButtons[index]

      if (list.scrollWidth > list.clientWidth) {
        prevButton.style.display = 'block'
        nextButton.style.display = 'block'

        if (list.scrollLeft === 0) {
          prevButton.disabled = true
        } else {
          prevButton.disabled = false
        }

        if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
          nextButton.disabled = true
        } else {
          nextButton.disabled = false
        }
      } else {
        prevButton.style.display = 'none'
        nextButton.style.display = 'none'
      }
    })
  }

  set addingToCart (value) {
    this.state.addingToCart = value

    if (this.elements.triggers.length === 1) {
      const singleTrigger = this.elements.triggers[0]

      singleTrigger.disabled = value
      singleTrigger.textContent = value ? `${window.productFormStrings.addingToCart}` : `${window.productFormStrings.addToCart}`
    }
  }
}

customElements.define('product-card-quick-add', ProductCardQuickAdd)
